import { FC, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

import { fetchApiInfo } from "src/api/info.ts";
import { getConfig } from "src/config.ts";
import { Info } from "src/model/info.ts";
import { formatDateTime } from "src/utils/timeFormat.ts";

export const AboutPage: FC = () => {
  const config = getConfig();
  const [apiInfo, setApiInfo] = useState<Info>();

  useEffect(() => {
    fetchApiInfo().then((info) => setApiInfo(info));
  }, [config]);

  console.log(apiInfo);

  return (
    <>
      <Helmet>
        <title>iSEAtrace - About</title>
      </Helmet>
      <div className="d-flex flex-wrap">
        <div style={{ width: "440px" }} className="mx-4 my-3">
          <div className="bg-white shadow">
            <div className="d-flex justify-content-center fw-bold bg-dark-subtle p-3">Frontend</div>
            <div className="p-3 pb-1 fs-6">
              <Table>
                <tbody>
                  <tr>
                    <td>Environment</td>
                    <td className="text-end">{config.environment}</td>
                  </tr>
                  <tr>
                    <td>Build Time</td>
                    <td className="text-end">{formatDateTime(config.buildTime)}</td>
                  </tr>
                  <tr>
                    <td>Release</td>
                    <td className="text-end">{config.release}</td>
                  </tr>
                  <tr>
                    <td>Api Url</td>
                    <td className="text-end">{config.apiUrl}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
        <div style={{ width: "440px" }} className="mx-4 my-3">
          <div className="bg-white shadow">
            <div className="d-flex justify-content-center fw-bold bg-dark-subtle p-3">Backend</div>
            <div className="p-3 pb-1 fs-6">
              {apiInfo ? (
                <Table>
                  <tbody>
                    <tr>
                      <td>Environment</td>
                      <td className="text-end">{apiInfo.environment}</td>
                    </tr>
                    <tr>
                      <td>Build Time</td>
                      <td className="text-end">{formatDateTime(apiInfo.buildTime)}</td>
                    </tr>
                    <tr>
                      <td>Release</td>
                      <td className="text-end">{apiInfo.release}</td>
                    </tr>
                  </tbody>
                </Table>
              ) : (
                <div className="p-4 text-center">Loading...</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
